import { __extends } from "tslib";
import * as React from 'react';
import s from './mobile-menu.scss';
import { Divider, Text, Collapse } from 'wix-style-react';
import X from 'wix-ui-icons-common/X';
import ChevronRightLarge from 'wix-ui-icons-common/ChevronRightLarge';
import { httpClient } from '../../http-client';
import { dtoToMenuProps } from '../../components/marketplace-menu';
import { AppMarketLink } from '../app-market-link';
import { config } from '../../config';
import { OriginQueryParam, Path } from '../../enums/marketplace-enums';
import { MobileMenuUserDetails } from './mobile-menu-user-details/mobile-menu-user-details';
import { MobileMenuLanguages } from './MobileMenuLanguages/mobile-menu-languages';
import { composer } from '../../component-decorators/composer';
import { useConfigContext } from '../../config-context';
export var MobileMenu = composer()
    .withTranslation()
    .withExperiments()
    .compose(function (_a) {
    var toggleMenu = _a.toggleMenu, isMenuOpen = _a.isMenuOpen, experiments = _a.experiments, t = _a.t;
    var shouldShowLanguages = experiments.enabled('specs.marketplace.use-new-marketplace');
    // tslint:disable-next-line: react-hooks-nesting
    var locale = useConfigContext().locale;
    var showHolidaySale = experiments.enabled('specs.marketplace.blackFridaySale');
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s.mobileMenu + " " + (isMenuOpen ? s.open : ''), "data-testid": "mobile-menu-container" },
            React.createElement("div", { className: s.innerContainer },
                React.createElement("div", { className: s.topSection },
                    React.createElement("a", { href: "/app-market" },
                        React.createElement("img", { "data-testid": "wix-logo", alt: "wix logo", src: config.marketplaceStaticsUrl + "assets/images/wix-app-market-new-logo.svg" })),
                    React.createElement(X, { size: '30px', onClick: toggleMenu })),
                React.createElement(MobileMenuSections, { closeMenu: toggleMenu, locale: locale, showHolidaySale: showHolidaySale, t: t }),
                shouldShowLanguages && React.createElement(MobileMenuLanguages, null),
                React.createElement(Divider, null),
                React.createElement("div", { className: s.userDetailsContainer },
                    React.createElement(MobileMenuUserDetails, null))))));
});
var MobileMenuSections = /** @class */ (function (_super) {
    __extends(MobileMenuSections, _super);
    function MobileMenuSections(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleSection = function (i) { return function () {
            _this.setState(function (prevState) { return ({
                openIndex: prevState.openIndex === i ? -1 : i,
            }); });
        }; };
        _this.isSectionOpen = function (i) { return i === _this.state.openIndex; };
        _this.state = {
            openIndex: -1,
            sections: [],
        };
        return _this;
    }
    MobileMenuSections.prototype.componentDidMount = function () {
        var _this = this;
        var baseURl = 'marketplace-api/v1';
        httpClient
            .get(config.baseApiUrl + "/_api/" + baseURl + "/container?platformName=" + OriginQueryParam.STANDALONE + "&containerName=menu&lang=" + this.props.locale)
            .then(function (_a) {
            var data = _a.data;
            _this.setState({ sections: dtoToMenuProps(data), openIndex: 0 });
        });
    };
    MobileMenuSections.prototype.render = function () {
        var _this = this;
        return this.state.sections.map(function (_a, i) {
            var id = _a.id, type = _a.type, tagData = _a.sectionData.tagData;
            return (React.createElement(React.Fragment, null,
                React.createElement(Divider, { key: "divider-" + tagData.displayName }),
                React.createElement("div", { key: tagData.displayName, className: s.sectionContainer + " " + (_this.isSectionOpen(i) ? s.openSection : '') },
                    React.createElement("span", { className: s.mobileMenuSectionTop, onClick: _this.toggleSection(i) },
                        React.createElement(Text, { weight: "bold", size: "small" }, tagData.displayName),
                        React.createElement(ChevronRightLarge, { className: s.arrow })),
                    React.createElement(SectionLinks, { closeMenu: _this.props.closeMenu, type: type, links: tagData.tagsToWebSolutions, isOpen: _this.isSectionOpen(i), menuIndex: i, showHolidaySale: _this.props.showHolidaySale, t: _this.props.t }))));
        });
    };
    return MobileMenuSections;
}(React.Component));
var SectionLinks = function (_a) {
    var isOpen = _a.isOpen, links = _a.links, type = _a.type, closeMenu = _a.closeMenu, menuIndex = _a.menuIndex, showHolidaySale = _a.showHolidaySale, t = _a.t;
    var getPath = function () {
        if (type === 'categoriesList') {
            return Path.CATEGORY;
        }
        return Path.COLLECTION;
    };
    return (React.createElement(Collapse, { open: isOpen },
        React.createElement("ul", { className: s.links },
            menuIndex === 0 && showHolidaySale && (React.createElement("li", null,
                React.createElement(AppMarketLink, { to: Path.COLLECTION + "/pre-holiday-sale", onClick: function () {
                        config.goto({
                            path: Path.CATEGORY,
                            slug: 'pre-holiday-sale',
                            referral: 'holiday-sale-mobile',
                        });
                        closeMenu();
                    } },
                    React.createElement(Text, { weight: 'normal', size: "small", className: s.titleMobile }, t('home.sideMenu.holidaySale'))))),
            links.map(function (_a) {
                var tag = _a.tag;
                return (React.createElement("li", { key: tag.name },
                    React.createElement(AppMarketLink, { to: getPath() + "/" + tag.slug, onClick: function () {
                            config.goto({
                                path: getPath(),
                                slug: tag.slug,
                                query: 'limit=200',
                            });
                            closeMenu();
                        } },
                        React.createElement(Text, { weight: 'normal', size: "small" }, tag.name))));
            }))));
};
//# sourceMappingURL=mobile-menu.js.map